import $ from 'jquery';
import registerSelect2 from 'select2';

if (!$.fn.select2) {
    registerSelect2(window, $);
}

$('.select-multiple').select2({
    placeholder: '',
    closeOnSelect: false,
});
